import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { updateBodyClass } from 'src/helpers';
import { DOCUMENTS_DETAIL_URL, DOC_UPLOAD_NEW_URL, BODY_CLASSES, DOCUMENTS_URL } from 'src/constants/constants.js';
import { connect } from 'react-redux';
import DocumentsLandingContainer from 'src/ui/features/Documents/containers/DocumentsLandingContainer';
import DocumentsDetailContainer from 'src/ui/features/Documents/containers/DocumentsDetailContainer';
import DocumentsUploadContainer from 'src/ui/features/Documents/containers/DocUploadContainer';
import intl from 'react-intl-universal';
import { newDashboardRoutes } from 'src/newDashboardRoutes';

class DocumentsRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.DOCUMENTS);
  }
  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.DOCUMENTS);
  }
  render() {
    return (
      <Layout headerName={intl.get('documents.title')}>
        <Switch>
          <Route path={`${DOC_UPLOAD_NEW_URL}/:caseId?/:clientId?`} render={props => <DocumentsUploadContainer {...props} />} />
          <Route
            path={DOCUMENTS_DETAIL_URL + '/:caseId/:documentId/:documentKey'}
            render={props =>
              this.props.login.userRoles.applicant ? <Redirect to={DOCUMENTS_URL} /> : <DocumentsDetailContainer {...props} />
            }
          />
          <Route path={DOCUMENTS_DETAIL_URL + '/:documentId/:documentKey'} render={props => <DocumentsDetailContainer {...props} />} />
          <Route path={DOCUMENTS_URL} render={props => <DocumentsLandingContainer {...props} />} />
        </Switch>
        {newDashboardRoutes}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(DocumentsRoot);
